import React from "react";
import { mediaUrl, mediaSet } from "../../services/api";

/**
 * A picture the way spec 09 wants it delivered: AVIF, then WebP, then the
 * JPEG/PNG fallback, each in the size the slot needs (`sizes`), lazy by
 * default, with its width and height reserved so nothing jumps as it loads.
 *
 *   <Picture src={retreat.image} sizes="(min-width: 992px) 33vw, 100vw" width={600} height={400} />
 *
 * Above-the-fold heroes pass loading="eager" and priority so they are
 * fetched first. Pictures without sized copies render as a plain <img>.
 */
const Picture = ({ src, alt = "", sizes = "100vw", width, height, loading = "lazy", priority = false, className, style, ...rest }) => {
  const set = mediaSet(src);
  const img = (
    <img
      src={mediaUrl(src)}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : loading}
      decoding="async"
      {...(priority ? { fetchpriority: "high" } : {})}
      className={className}
      style={style}
      {...rest}
    />
  );
  if (!set) return img;
  return (
    <picture className="mk-picture">
      <source type="image/avif" srcSet={set.avif} sizes={sizes} />
      <source type="image/webp" srcSet={set.webp} sizes={sizes} />
      {img}
    </picture>
  );
};

export default Picture;
